import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../../../../components/ui/Input';
import { Checkbox } from '../../../../../components/ui/Checkbox';
import type { FooterSettings as FooterSettingsType } from '../types';

interface FooterSettingsProps {
  settings: FooterSettingsType;
  onUpdate: (field: keyof FooterSettingsType, value: unknown) => void;
}

const FooterSettings: React.FC<FooterSettingsProps> = ({ settings, onUpdate }) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      <h4 className="text-sm font-medium text-foreground mb-4">
        {t('Footer Settings')}
      </h4>

      <div className="space-y-4">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-foreground">
            {t('Footer Text')}
          </label>
          <textarea
            value={settings.footerText}
            onChange={(e) => onUpdate('footerText', e.target.value)}
            className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            rows={2}
            placeholder={t('This is an official document...')}
          />
        </div>

        <Checkbox
          checked={settings.includeDisclaimer}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onUpdate('includeDisclaimer', e.target.checked)
          }
          label={t('Include disclaimer')}
        />

        {settings.includeDisclaimer && (
          <div className="space-y-2">
            <label className="block text-sm font-medium text-foreground">
              {t('Disclaimer Text')}
            </label>
            <textarea
              value={settings.disclaimerText}
              onChange={(e) => onUpdate('disclaimerText', e.target.value)}
              className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              rows={2}
              placeholder={t('This document is confidential...')}
            />
          </div>
        )}

        <div className="flex items-center gap-6 flex-wrap">
          <Checkbox
            checked={settings.showHelpContact}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onUpdate('showHelpContact', e.target.checked)
            }
            label={t('Show help contact')}
          />

          {settings.showHelpContact && (
            <div className="flex-1 max-w-[12rem]">
              <Input
                value={settings.helpContact}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  onUpdate('helpContact', e.target.value)
                }
                placeholder="hr@company.com"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FooterSettings;
